<!-- TDO Dialog Template -->
<div style="width: 90vw; height: 85vh; max-width: 1400px; max-height: 800px; min-width: 800px; min-height: 600px; overflow: hidden; box-sizing: border-box;" data-cy="vital-signs-dialog">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%; overflow: hidden;">
    <div class="section-header" style="flex-basis: 50px; flex-shrink: 0; display: flex; align-items: center; justify-content: space-between;" data-cy="vital-signs-header-section">
      <div class="section-header-title" data-cy="vital-signs-title-text">
        Vital Signs
      </div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow: hidden; padding: 20px; box-sizing: border-box;" data-cy="vital-signs-content">

      <!-- Loading Indicator -->
      @if (isLoading) {
        <div style="display: flex; justify-content: center; align-items: center; height: 200px;" data-cy="vital-signs-loading">
          <mat-spinner diameter="40"></mat-spinner>
          <span style="margin-left: 16px; color: var(--tdo-text);">Loading vital signs...</span>
        </div>
      }

      @if (!isLoading) {
        <div>
          <!-- Units Selection and Add Button -->
          <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;" data-cy="vital-signs-controls-row">
            <div style="display: flex; align-items: center;" data-cy="vital-signs-units-row">
              <label style="margin-right: 10px; font-weight: 500;">Units:</label>
              <tdo-dropdown-v2
                [datasource]="unitsOptions"
                [displayPredicate]="unitsPredicate"
                [value]="selectedUnits"
                (selectionChange)="onUnitsSelectionChange($event)"
                placeholder="Select Units"
                style="width: 150px;"
                data-cy="vital-signs-units-dropdown">
              </tdo-dropdown-v2>
            </div>
            <button class="tdo-button tdo-save" (click)="onAddClick()" data-cy="vital-signs-add-button">Add</button>
          </div>
          <!-- Vital Signs Table -->
          <div style="flex: 1; border: 1px solid #ddd; border-radius: 4px; height: 400px; min-height: 400px; max-height: 400px; overflow-y: auto;" data-cy="vital-signs-table">
            <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
              <thead style="position: sticky; top: 0; z-index: 10; background: white;">
                <tr style="background: linear-gradient(135deg, #4FC3F7 0%, #29B6F6 100%);">
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; border-right: 1px solid rgba(255,255,255,0.2); width: 280px;" data-cy="vital-signs-header-taken">Taken</th>
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; border-right: 1px solid rgba(255,255,255,0.2); width: 100px;" data-cy="vital-signs-header-anesthesia">Anesthesia</th>
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; border-right: 1px solid rgba(255,255,255,0.2); width: 100px;" data-cy="vital-signs-header-weight">Weight</th>
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; border-right: 1px solid rgba(255,255,255,0.2); width: 150px;" data-cy="vital-signs-header-height">Height</th>
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; border-right: 1px solid rgba(255,255,255,0.2); width: 90px;" data-cy="vital-signs-header-systolic">Systolic</th>
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; border-right: 1px solid rgba(255,255,255,0.2); width: 90px;" data-cy="vital-signs-header-diastolic">Diastolic</th>
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; border-right: 1px solid rgba(255,255,255,0.2); width: 100px;" data-cy="vital-signs-header-temp">Temp</th>
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; border-right: 1px solid rgba(255,255,255,0.2); width: 90px;" data-cy="vital-signs-header-o2">O2 %</th>
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; border-right: 2px solid rgba(255,255,255,0.4); width: 90px;" data-cy="vital-signs-header-pulse">Pulse</th>
                  <th style="padding: 4px; color: white; font-weight: 500; text-align: center; width: 70px;" data-cy="vital-signs-header-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <!-- All Entries (editable rows) -->
                @for (entry of allEntries; track entry; let i = $index) {
                  <tr style="border-bottom: 1px solid #ddd;"
                    [attr.data-cy]="'vital-signs-entry-' + i">
                    <!-- Taken -->
                    <td style="padding: 3px; border-right: 1px solid #ddd; vertical-align: top; width: 280px;" [attr.data-cy]="'vital-signs-taken-cell-' + i">
                      @if (entry.isExisting) {
                        <div style="font-size: 14px; line-height: 1.2;">
                          <div style="display: flex; flex-direction: row; align-items: center; gap: 8px; text-align: left;">
                            <span>{{entry.taken}}</span>
                            <span style="color: #666; font-size: 13px;">{{entry.takenBy}}</span>
                          </div>
                        </div>
                      }
                      @if (!entry.isExisting) {
                        <div style="display: flex; flex-direction: row; gap: 4px; align-items: center;">
                          <app-tdo-input [isHideUnderline]="true"
                            type="text"
                            [(ngModel)]="entry.taken"
                            [disabled]="false"
                            placeholder="Date/Time"
                            width="135"
                            [attr.data-cy]="'vital-signs-taken-input-' + i">
                          </app-tdo-input>
                          <app-tdo-input [isHideUnderline]="true"
                            type="text"
                            [(ngModel)]="entry.takenBy"
                            [disabled]="false"
                            placeholder="User"
                            width="135"
                            [attr.data-cy]="'vital-signs-taken-by-input-' + i">
                          </app-tdo-input>
                        </div>
                      }
                    </td>
                    <!-- Anesthesia -->
                    <td style="padding: 3px; border-right: 1px solid #ddd; text-align: left; width: 100px;" [attr.data-cy]="'vital-signs-anesthesia-cell-' + i">
                      @if (entry.isExisting && entry.anesthesiaAdministered) {
                        <lucide-icon name="check" [size]="20" style="color: green; font-size: 16px;"></lucide-icon>
                      }
                      @if (entry.isExisting && !entry.anesthesiaAdministered) {
                        <span>-</span>
                      }
                      @if (!entry.isExisting) {
                        <span style="color: #999; font-size: 11px;">N/A</span>
                      }
                    </td>
                    <!-- Weight -->
                    <td style="padding: 3px; border-right: 1px solid #ddd; width: 100px;" [attr.data-cy]="'vital-signs-weight-cell-' + i">
                      @if (entry.isExisting) {
                        <div style="text-align: left; font-size: 14px;">
                          {{entry.weight || '-'}} @if (entry.weight) {
                          <span style="color: #666;">{{ getUnitDisplayText(entry.weightUnitId) }}</span>
                        }
                      </div>
                    }
                    @if (!entry.isExisting) {
                      <div style="display: flex; align-items: center; justify-content: flex-start; gap: 2px;">
                        <app-tdo-input [isHideUnderline]="true"
                          type="number"
                          [(ngModel)]="entry.weight"
                          placeholder=""
                          width="50"
                          [attr.data-cy]="'vital-signs-weight-input-' + i">
                        </app-tdo-input>
                        <span style="font-size: 11px; color: #666;">{{ selectedUnits?.value === 'metric' ? 'Kg' : 'Lbs' }}</span>
                      </div>
                    }
                  </td>
                  <!-- Height -->
                  <td style="padding: 3px; border-right: 1px solid #ddd; width: 150px;" [attr.data-cy]="'vital-signs-height-cell-' + i">
                    @if (entry.isExisting) {
                      <div style="text-align: left; font-size: 14px;">
                        @if (entry.height || entry.height2) {
                          <div>
                            @if (entry.height) {
                              <span>{{entry.height}} {{ getUnitDisplayText(entry.heightUnitId) }}</span>
                            }
                            @if (entry.height && entry.height2) {
                              <span> </span>
                            }
                            @if (entry.height2) {
                              <span>{{entry.height2}} {{ getSecondHeightUnitText(entry.heightUnitId) }}</span>
                            }
                          </div>
                        }
                        @if (!entry.height && !entry.height2) {
                          <div>-</div>
                        }
                      </div>
                    }
                    @if (!entry.isExisting) {
                      <div style="display: flex; align-items: center; justify-content: flex-start; gap: 1px;">
                        <app-tdo-input [isHideUnderline]="true"
                          type="number"
                          [(ngModel)]="entry.height"
                          placeholder=""
                          width="45"
                          [attr.data-cy]="'vital-signs-height-input-' + i">
                        </app-tdo-input>
                        <span style="font-size: 10px; color: #666;">{{ selectedUnits?.value === 'metric' ? 'm' : 'ft' }}</span>
                        <app-tdo-input [isHideUnderline]="true"
                          type="number"
                          [(ngModel)]="entry.height2"
                          placeholder=""
                          width="45"
                          [attr.data-cy]="'vital-signs-height2-input-' + i">
                        </app-tdo-input>
                        <span style="font-size: 10px; color: #666;">{{ selectedUnits?.value === 'metric' ? 'cm' : 'in' }}</span>
                      </div>
                    }
                  </td>
                  <!-- Systolic -->
                  <td style="padding: 3px; border-right: 1px solid #ddd; text-align: left; width: 90px;" [attr.data-cy]="'vital-signs-systolic-cell-' + i">
                    @if (entry.isExisting) {
                      <div style="font-size: 14px;">
                        {{entry.systolic || '-'}}
                      </div>
                    }
                    @if (!entry.isExisting) {
                      <app-tdo-input [isHideUnderline]="true"
                        type="number"
                        [(ngModel)]="entry.systolic"
                        placeholder=""
                        width="55"
                        [attr.data-cy]="'vital-signs-systolic-input-' + i">
                      </app-tdo-input>
                    }
                  </td>
                  <!-- Diastolic -->
                  <td style="padding: 3px; border-right: 1px solid #ddd; text-align: left; width: 90px;" [attr.data-cy]="'vital-signs-diastolic-cell-' + i">
                    @if (entry.isExisting) {
                      <div style="font-size: 14px;">
                        {{entry.diastolic || '-'}}
                      </div>
                    }
                    @if (!entry.isExisting) {
                      <app-tdo-input [isHideUnderline]="true"
                        type="number"
                        [(ngModel)]="entry.diastolic"
                        placeholder=""
                        width="55"
                        [attr.data-cy]="'vital-signs-diastolic-input-' + i">
                      </app-tdo-input>
                    }
                  </td>
                  <!-- Temperature -->
                  <td style="padding: 3px; border-right: 1px solid #ddd; width: 100px;" [attr.data-cy]="'vital-signs-temp-cell-' + i">
                    @if (entry.isExisting) {
                      <div style="text-align: left; font-size: 14px;">
                        {{entry.temperature || '-'}} @if (entry.temperature) {
                        <span style="color: #666;">{{ getUnitDisplayText(entry.temperatureUnitId) }}</span>
                      }
                    </div>
                  }
                  @if (!entry.isExisting) {
                    <div style="display: flex; align-items: center; justify-content: flex-start; gap: 3px;">
                      <app-tdo-input [isHideUnderline]="true"
                        type="number"
                        [(ngModel)]="entry.temperature"
                        placeholder=""
                        width="55"
                        [attr.data-cy]="'vital-signs-temp-input-' + i">
                      </app-tdo-input>
                      <span style="font-size: 11px; color: #666;">{{ selectedUnits?.value === 'metric' ? '°C' : '°F' }}</span>
                    </div>
                  }
                </td>
                <!-- O2 % -->
                <td style="padding: 3px; border-right: 1px solid #ddd; text-align: left; width: 90px;" [attr.data-cy]="'vital-signs-o2-cell-' + i">
                  @if (entry.isExisting) {
                    <div style="font-size: 14px;">
                      {{entry.oxygenSaturation || '-'}}
                    </div>
                  }
                  @if (!entry.isExisting) {
                    <app-tdo-input [isHideUnderline]="true"
                      type="number"
                      [(ngModel)]="entry.oxygenSaturation"
                      placeholder=""
                      width="55"
                      [attr.data-cy]="'vital-signs-o2-input-' + i">
                    </app-tdo-input>
                  }
                </td>
                <!-- Pulse -->
                <td style="padding: 3px; border-right: 2px solid #ddd; text-align: left; width: 90px;" [attr.data-cy]="'vital-signs-pulse-cell-' + i">
                  @if (entry.isExisting) {
                    <div style="font-size: 14px;">
                      {{entry.pulse || '-'}}
                    </div>
                  }
                  @if (!entry.isExisting) {
                    <div style="position: relative;">
                      <app-tdo-input [isHideUnderline]="true"
                        type="number"
                        [(ngModel)]="entry.pulse"
                        placeholder=""
                        width="55"
                        [min]="MIN_PULSE"
                        [max]="MAX_PULSE"
                        [class.invalid-pulse]="entry.pulse && !isPulseValid(entry.pulse)"
                        [attr.data-cy]="'vital-signs-pulse-input-' + i">
                      </app-tdo-input>
                      @if (entry.pulse && !isPulseValid(entry.pulse)) {
                        <div
                          class="pulse-validation-error"
                          [title]="getPulseValidationMessage(entry.pulse)">
                          ⚠️
                        </div>
                      }
                    </div>
                  }
                </td>
                <!-- Actions -->
                <td style="padding: 3px; text-align: center; width: 70px;" [attr.data-cy]="'vital-signs-actions-cell-' + i">
                  @if (canDeleteEntry(entry)) {
                    <button
                      class="tdo-button-icon"
                      (click)="onDeleteEntry(i)"
                      matTooltip="Delete Entry"
                      style="background: none; border: none; cursor: pointer; padding: 4px;"
                      [attr.data-cy]="'vital-signs-delete-button-' + i">
                      <lucide-icon name="trash-2" [size]="20" style="color: #d32f2f; transform: scale(1.2, 1.2); font-size: 20px;"></lucide-icon>
                    </button>
                  }
                  @if (!canDeleteEntry(entry)) {
                    <span
                      matTooltip="Cannot delete records older than 24 hours"
                      style="color: #999; font-size: 11px;">
                      -
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    } <!-- End of !isLoading -->
  </div>
  <!--  FOOTER-->
  <div class="section-footer" style="flex-basis: 46px; flex-shrink: 0; padding: 12px 20px 12px 6px; display: flex; align-items: center;" data-cy="vital-signs-footer">
    <div style="flex: 1; margin-right: 6px;"></div>
    <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 12px;" data-cy="vital-signs-cancel-button">Cancel</button>
    <button (click)="onSaveClick()" class="tdo-button tdo-save" style="margin-right: 0;" [disabled]="isLoading || !hasValidEntries()" data-cy="vital-signs-save-button">Save</button>
  </div>
</div>
</div>
